import * as _ from 'underscore';
import { IID as IID_Mvc, ID as ID_Mvc } from '@mae/mvc/const';

export interface IID extends IID_Mvc {
	Activation: string;
	AppTypeLabel: string;
	Application: string;
	AutomaticTheming: string;
	Blocked: string;
	Browser: string;
	Cache: string;
	ChangePassword: string;
	ChargeFile: string;
	ClaimLabel: string;
	Clone: string;
	Connection: string;
	ConnectionSection: string;
	ConnectionString: string;
	Content: string;
	CurrentPassword: string;
	DarkThemeKey: string;
	Darkmode: string;
	Database: string;
	Datasource: string;
	Description: string;
	DisableTwoFactor: string;
	DisableTwoFactorAuthentication: string;
	DisplayName: string;
	Email: string;
	EnableTwoFactor: string;
	Filter: string;
	Fullname: string;
	HidePassword: string;
	Host: string;
	Imagery: string;
	InitialCatalog: string;
	InitialCharge: string;
	LanguageCode: string;
	LoadingArea: string;
	LogList: string;
	Login: string;
	LoginUserEmail: string;
	Logs: string;
	MApps: string;
	MissingTenant: string;
	Mobile: string;
	Name: string;
	NewConnection: string;
	NewPassword: string;
	NewPasswordConfirm: string;
	OverViews: string;
	Port: string;
	PrintLayouts: string;
	Provider: string;
	Queries: string;
	Refresh: string;
	Reset: string;
	ResetPassword: string;
	SRID: string;
	Security: string;
	SetupTwoFactorAuthentication: string;
	StartDateTime: string;
	Studio: string;
	StudioAccount: string;
	StyleSets: string;
	Sync: string;
	Table: string;
	Theming: string;
	TileGrid: string;
	Token: string;
	TwoFactorRequired: string;
	User: string;
	UserEmail: string;
	Username: string;
	Users: string;
	VectorData: string;
	Workflows: string; 
}; 

export const ID: IID = _.extend({}, ID_Mvc, {
	Activation: 'activation',
	AppTypeLabel: 'appTypeLabel',
	Application: 'mapp-enterprise-studio',
	AutomaticTheming: 'automaticTheming',
	Blocked: 'blocked',
	Browser: 'browser',
	Cache: 'cache',
	ChangePassword: 'changepassword',
	ChargeFile: 'chargefile',
	ClaimLabel: 'claimLabel',
	Clone: 'clone',
	Connection: 'connection',
	ConnectionSection: 'connections',
	ConnectionString: 'connectionString',
	Content: 'content',
	CurrentPassword: 'currentpassword',
	DarkThemeKey: 'dark-theme',
	Darkmode: 'darkmode',
	Database: 'database',
	Datasource: 'datasource',
	Description: 'description',
	DisableTwoFactor: 'disabletwofactor',
	DisableTwoFactorAuthentication: 'disableTwoFactorAuthentication',
	DisplayName: 'displayName',
	Email: 'email',
	EnableTwoFactor: 'enabletwofactor',
	Filter: 'filter',
	Fullname: 'fullname',
	HidePassword: 'hidepassword',
	Host: 'host',
	Imagery: 'imagery',
	InitialCatalog: 'initialcatalog',
	InitialCharge: 'initialcharge',
	LanguageCode: 'languagecode',
	LoadingArea: '.mapp-loading-area',
	LogList: 'logList',
	Login: 'login',
	LoginUserEmail: 'loginUserEmail',
	Logs: 'logs',
	MApps: 'mapps',
	MissingTenant: 'missingtenant',
	Mobile: 'mobile',
	Name: 'name',
	NewConnection: 'newconnection',
	NewPassword: 'newpassword',
	NewPasswordConfirm: 'newpasswordconfirm',
	OverViews: 'overviews',
	Port: 'port',
	PrintLayouts: 'printlayouts',
	Provider: 'provider',
	Queries: 'queries',
	Refresh: 'refresh',
	Reset: 'reset',
	ResetPassword: 'resetPassword',
	SRID: 'srid',
	Security: 'security',
	SetupTwoFactorAuthentication: 'setupTwoFactorAuthentication',
	StartDateTime: 'startdatetime',
	Studio: 'studio',
	StudioAccount: 'studioAccount',
	StyleSets: 'stylesets',
	Sync: 'sync',
	Table: 'table',
	Theming: 'theming',
	TileGrid: 'tilegrid',
	Token: 'token',
	TwoFactorRequired: 'twofactorrequired',
	User: 'user',
	UserEmail: 'userEmail',
	Username: 'username',
	Users: 'users',
	VectorData: 'vectordata',
	Workflows: 'workflows' 
});